<template>
  <div v-show="show" v-bind:style="position" class="popover-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      position: ''
    }
  },
  watch: {
    show (newValue, old) {
      // Build up the new position
      switch (this.orientation) {
        case 'Top':
          this.position = `
            top: ${(this.event.target.offsetTop - (this.space + this.event.target.offsetHeight))}px;
            left: ${this.event.target.offsetLeft}px;
          `
          break
        case 'Bottom':
          this.position = `
            top: ${(this.event.target.offsetHeight + this.event.target.offsetTop + this.space)}px;
            left: ${this.event.target.offsetLeft}px;
          `
          break
        case 'Left':
          this.position = `
            top: ${this.event.target.offsetTop}px;
            left: ${(this.event.target.offsetLeft - this.event.target.offsetWidth)}px;
          `
          break
        case 'Right':
          this.position = `
            top: ${this.event.target.offsetTop}px;
            left: ${(this.event.target.offsetWidth + this.event.target.offsetLeft + this.space)}px;
          `
          break
      }
    }
  },
  name: 'Popover',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    space: {
      type: Number,
      default: 5
    },
    event: {
      required: true
    },
    orientation: {
      type: String,
      default: 'Bottom'
    }
  }
}
</script>

<style lang="scss">
@import "../styles/theme";

.popover-container {
  position: absolute;
  font-size: 12px;
  z-index: 10000;
  background: $background-white;
  border: none;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(136,152,170,.1), 0 15px 35px 0 rgba(49,49,93,.1), 0 5px 15px 0 rgba(0,0,0,.13);
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Popover.vue